/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1", "key": "svg-1" }], ["path", { "d": "M12 7v10", "key": "svg-2" }]];
const IconCoin = createReactComponent("outline", "coin", "Coin", __iconNode);

export { __iconNode, IconCoin as default };
//# sourceMappingURL=IconCoin.mjs.map
